<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/160trdm/tc-custom/9780369700292.jpg?1743830549310" alt="This image is the cover for the book Hideaway"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hideaway
      </h1>
      <p class="bookDescription body article font2">
        <b>A safe haven…turned deadly</b><br/><br/>As an ER doctor, Cheyenne Allison is used to handling emergencies—until her own sister codes on the trauma bed. Devastated, Cheyenne retreats to an isolated farm in Hideaway, Missouri. But peace and solitude are in short supply in this picturesque Ozarks town. A dangerous vandal has the community terrorized, and Cheyenne finds an unexpected demand for her medical skills.<br/><br/>Mayor Austin Barlow is convinced the culprit resides with Cheyenne’s charismatic neighbor, Dane Gideon, whose ranch for foster boys has given rise to previous violence. Cheyenne distrusts Austin, while Dane inspires her respect, and perhaps something more—although she can’t share the faith that sustains him as the violence turns deadly. Then Cheyenne, already pursued by a past nemesis, becomes the vandal’s target, and she can only hope that Hideaway will prove her sanctuary…and perhaps a place to call home.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hannah Alexander
      </h2>
      
      <p class="authorDescription body article">Hannah Alexander is the pen name for Cheryl Hodde, who uses the medical input from her husband, Dr. Mel Hodde, to write romantic suspense with medical emphasis, both contemporary and historical. Their first collaboration began with a blind date instigated by Cheryl's matchmaking pastor, and has continued for the fifteen years of their marriage.  Discover more about their work at www.hannahalexander.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?129f591a